////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { Link, useLocation } from 'react-router-dom'
import { useSelector, shallowEqual } from 'react-redux'
import { isUndefined, map, includes } from 'lodash'
/////////ASSETS/////////
import Home from '../../../assets/icones/global/home.svg'

/////////STYLED/////////
const BreadCrumbWrapper = styled.div`
	background-color: ${(props) => props.theme.colors.menu.wrapper};
	height: 29px;
	display: flex;
	justify-content: flex-start;
	align-items: center;
`
const BreadCrumbPart = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	margin-left: 16px;
	color: ${(props) => props.theme.colors.white};
	font-size: ${(props) => props.theme.font.fxs};
`
const HomeIMG = styled.img`
	height: 18px;
	width: 18px;
	margin-right: 7px;
`
/////////STYLED/////////

const BreadCrumb = ({ breadCrumbs, firstParent }) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	const location = useLocation()

	let str_bc = ''

	// We expect routes to be filled,
	// even a route without parent is handled like it has child, for avoiding route conflicts
	map(breadCrumbs.routes, (elem) => {
		if (includes(location.pathname, elem.pathName)) {
			str_bc = `${firstParent?.breadCrumb ? translations[firstParent?.breadCrumb] : ''} ${
				!isUndefined(breadCrumbs.parentBreadCrumb) ? translations[breadCrumbs.parentBreadCrumb] : ''
			} ${translations[breadCrumbs.breadCrumb]} ${translations[elem.breadCrumb]}`
		}
	})

	// On home, no breadcrumb
	if (location.pathname === '/home') str_bc = ''

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<BreadCrumbWrapper>
			<BreadCrumbPart>
				<Link to="/home">
					<HomeIMG src={Home} />
				</Link>
				{/* `${ translations['header__breadcrumb__admin__home_main'] }  ${!isUndefined(breadCrumbs?.breadCrumb) ? translations[ breadCrumbs.breadCrumb] : "" }  ${!isUndefined(bc.breadCrumb) ? translations[bc.breadCrumb] : "" }`*/}
				{`${translations['header__breadcrumb__admin__home_main']} ${str_bc}`}
			</BreadCrumbPart>
		</BreadCrumbWrapper>
	)
}

BreadCrumb.propTypes = {}

export default BreadCrumb
